export class TextareaReplacementUtil {
  text: string;

  constructor(text = '') {
    this.text = text;
  }

  replacesOneNewLineWithTwo(v: string = this.text) {
    this.text = v ? v.replaceAll(/(?<!-)\n(?!-)/gi, '\n\n') : v;
    return this;
  }

  replacesTwoNewLinesWithOne(v: string = this.text) {
    this.text = v ? v.replaceAll(/(?<!-)(\n){2}/g, '\n') : v;
    return this;
  }

  // Fix for bug: FR-3889
  // See https://regexr.com/80cqr to see documentation on what this RegEx does
  replaceEmptyBulletListItem(v: string = this.text) {
    this.text = v ? v.replaceAll(/^ *((-+ *)+\n?$)+/gm, '') : v;
    return this;
  }

  // Fix for bug: FR-4511
  // See https://regexr.com/82d32 to see documentation on what this RegEx does
  replaceFourOrMoreStartingSpaces(v: string = this.text) {
    this.text = v ? v.replaceAll(/^(- )? {4,}/gm, '$1') : v;
    return this;
  }

  replaceUncommonBulletFormatToCommon(v: string = this.text) {
    if (!v) return this;

    const bulletCharacters = ['•', '●', '○', '§', '·', 'o', '-'];

    // formats unordered lists
    bulletCharacters.forEach(c => {
      // Create a regex to match bullet patterns at line start or tab start
      let bulletRegex = new RegExp(`(^|\\n)(\\s*)${c}\\s*`, 'g');
      // some users like to use the letter "o"
      if (c === 'o') {
        bulletRegex = new RegExp(`(^|\\n)(\\s*)${c}\\s+`, 'g');
      }

      v = v.replace(bulletRegex, '$1- ');

      // Replace the starting bullet with '- ' if it starts with the character followed by space or tab
      const bulletStartRegex = new RegExp(`^${c}[ \t]`);
      if (bulletStartRegex.test(v)) {
        v = v.replace(bulletStartRegex, '- ');
      }
    });

    // formats numeric lists
    const numericRegex = /(^|\n)(\s*)(\d[).])\s*/g;
    v = v.replaceAll(numericRegex, '$1$3 ');

    // Remove all tabs - tabs can cause text to not render in Textarea
    v = v.replaceAll('\t', '');

    // cleans up spacing when bulleted list is preceded by \n\n
    v = v.replaceAll('\n\n- ', '\n- ');

    this.text = v;
    return this;
  }

  getText() {
    return this.text;
  }
}
